/* global mtt_search_obj, console, windows, jQuery */

/**
 * Define the search bar and search area.
 * Setup the search bar and search area, if the exists on the page.
 *
 * @constructor
 */
const MTTSearch = function () {
  if (typeof this.mtt_search_ajax === 'undefined') {
    this.mtt_search_ajax = {} // This object will keep track of ajax status
  }

  this.ajax_url = mtt_search_obj.ajax_url
  this.bar_form = jQuery('form[' + mtt_search_obj.bar.selector + ']')
  this.area_form = jQuery('form[' + mtt_search_obj.area.selector + ']')
  if (this.bar_form.length > 0) {
    this.setupBar()
  }
  if (this.area_form.length > 0) {
    this.setupArea()
  }
}

/**
 * Setup bar, where it defines the search input, the wrapper and the result.
 * Makes an event if the input is changed.
 */
MTTSearch.prototype.setupBar = function () {
  this.bar_post_types = this.bar_form.find('[data-post_type]')
  this.bar_input = this.bar_form.find('[type="search"]')
  this.bar_input_mobile = this.bar_form.find('.mtt-filter-mobile-container input[type="search"]')
  this.bar_result_wrapper = this.bar_form.find('.result-wrapper')
  this.bar_result = this.bar_form.find('.result')
  this.bar_form.on('input', this.debounce(this.onBarChange.bind(this), 1000))
  jQuery(document).on('mousedown', this.onClick.bind(this))
}

/**
 * Shows the wrapper and show the loading icon.
 * Makes a Ajax call with the search string.
 *
 * @param e
 */
MTTSearch.prototype.onBarChange = function (e) {
  e.preventDefault()
  if (this.bar_input.val().length === 0) {
    this.toggleSearchWrapper(true)
    this.bar_result.html('')
    return
  }
  this.toggleLoading(this.bar_result_wrapper)
  this.toggleSearchWrapper()
  const data = {
    action: mtt_search_obj.bar.action,
    post_types: this.getPostTypes(this.bar_post_types),
    search_string: this.bar_input.val()
  }
  this.ajax(data, this.onBarAjaxCallback.bind(this))
}

/**
 * Check if there is an event, that is outside the bar_result_wrapper
 *
 * @param e
 */
MTTSearch.prototype.onClick = function (e) {
  if (this.bar_form && !jQuery(e.target).closest(this.bar_form).length) {
    this.toggleSearchWrapper(true)
  }
}

/**
 * Return from the Ajax call, where it remove the loading icon.
 * Changes the search result with the new result.
 *
 * @param response
 */
MTTSearch.prototype.onBarAjaxCallback = function (response) {
  this.toggleLoading(this.bar_result_wrapper, true)
  this.bar_result.html(response.data.html)
}

/**
 * Setup area, where it defines the inputs, the result and the pagination.
 * It defines the page number.
 * Makes an event if the input is changed and when the page is loaded.
 */
MTTSearch.prototype.setupArea = function () {
  this.area_post_types = this.area_form.find('[data-post_type]')
  this.category = this.area_form.find('[data-product_cat]')
  this.area_input = this.area_form.find('[type="search"]')
  this.area_taxonomies = this.area_form.find('[data-taxonomy]')
  this.area_slider_taxonomies = this.area_form.find('[data-slider-taxonomy]')
  this.area_posts_per_page = this.area_form.find('[name="posts_per_page"]')
  this.area_order = this.area_form.find('[name="order"]')
  this.area_products = this.area_form.find('.products')
  this.area_pages = []
  this.area_pages.push(parseInt(this.area_form.find('[name="page_number"]').val()))
  this.area_current_page = this.getStartPage()
  this.area_max_page = parseInt(this.area_form.find('input[name="area_max_page"]').val())
  this.resetFilter = this.area_form.find('button[name="reset-filters"]')

  this.setupSliders()
  this.setupPagination()

  this.setupFilter()
  this.setupMobileFilter()

  this.resetFilter.on('click', this.onResetAreaClick.bind(this))
  this.area_form.on('input', this.debounce(this.onAreaChange.bind(this), 1000))
  this.area_form.on('submit', this.stopSubmit.bind(this))
}

MTTSearch.prototype.setupSliders = function () {
  for (let i = 0; i < this.area_slider_taxonomies.length; i++) {
    const that = this
    const slider = jQuery(this.area_slider_taxonomies[i])
    const min = slider.parent().find('[data-slider-min-value]').data('slider-min-value')
    const max = slider.parent().find('[data-slider-max-value]').data('slider-max-value')

    slider.slider({
      range: true,
      min: min,
      max: max,
      values: [min, max],
      slide: function (event, ui) {
        slider.parent().find('[data-slider-min-value]').html(ui.values[0])
        slider.parent().find('[data-slider-max-value]').html(ui.values[1])

        that.handleSliderNumber(slider)
      },
      stop: function (event, ui) {
        that.debounce(that.onAreaChange(event), 1000)

        that.handleSliderNumber(slider)
      }
    })

    slider.parent().find('[data-slider-min-value]').html(slider.slider('values', 0))
    slider.parent().find('[data-slider-max-value]').html(slider.slider('values', 1))

    this.handleSliderNumber(slider)
  }
}

MTTSearch.prototype.handleSliderNumber = function (slider) {
  const sliders = slider.find('.ui-slider-handle.ui-corner-all.ui-state-default')
  slider.parent().find('[data-slider-min-value]').css('left', 'calc(' + sliders[0].style.left + ' - 3.5%)')
  slider.parent().find('[data-slider-max-value]').css('left', 'calc(' + sliders[1].style.left + ' - 3.5%)')
}

/**
 * Setup the pagination, where it defines the the pagination to previous products and more products.
 */
MTTSearch.prototype.setupPagination = function () {
  this.area_pagination_progress_count_prev = jQuery('.progress-count-prev')
  this.area_pagination_indicator_prev = jQuery('.progress-indicator-prev')
  this.area_pagination_load_prev = jQuery('[name="load-prev"]')
  if (this.area_current_page !== 1) {
    this.area_pagination_load_prev.on('click', this.onAreaLoadPrev.bind(this))
  }
  this.area_pagination_progress_count = jQuery('.progress-count')
  this.area_pagination_indicator = jQuery('.progress-indicator')
  this.area_pagination_load_more = jQuery('[name="load-more"]')
  this.area_pagination_load_more.on('click', this.onAreaLoadMore.bind(this))
}

/**
 * Setup the sidebar filters, so that you can hide them.
 */
MTTSearch.prototype.setupFilter = function () {
  const filter_item = document.querySelectorAll('.filter-item')
  const parent_dropdowns = document.querySelectorAll('.mtt-label-wrapper')
  const fl = jQuery(filter_item).length
  for (let i = 0; i < fl; i++) {
    jQuery(filter_item[i]).on('click', '.title', function () {
      const parent = jQuery(this).parent('.filter-item')

      if (parent.hasClass('filter-item-active')) {
        parent.removeClass('filter-item-active')
      } else {
        parent.addClass('filter-item-active')
      }
    })
  }

  if (parent_dropdowns.length) {
    for (let i = 0; i < parent_dropdowns.length; i++) {
      const parent_dropdown = parent_dropdowns[i]
      const children_wrapper = parent_dropdown.nextElementSibling
      const dropdown_item = parent_dropdown.querySelector('.mtt-term-has-children span')
      const input_element = parent_dropdown.querySelector('.mtt-term-has-children input')

      parent_dropdown.addEventListener('click', (e) => {
        if (e.target.tagName.toLowerCase() === 'span' || e.target.tagName.toLowerCase() === 'input') {
          return
        }

        if (children_wrapper) {
          parent_dropdown.classList.toggle('mtt-is-open')
          jQuery(children_wrapper).slideToggle()
        }
      })

      if (dropdown_item && children_wrapper && input_element) {
        dropdown_item.addEventListener('click', () => {
          if (!input_element.checked) {
            jQuery(children_wrapper).slideDown()
            parent_dropdown.classList.add('mtt-is-open')
          }
        })
      }
    }
  }
}

/**
 * Setup mobile sidebar filters.
 */
MTTSearch.prototype.setupMobileFilter = function () {
  if (document.querySelector('.mtt-filter-mobile')) {
    const FILTER_BTN = document.querySelector('.mtt-filter-mobile')
    const SIDE_BAR = document.querySelector('.mtt-filter-sidebar')
    const NAV_TOGGLE = document.getElementById('navigation-toggle')
    const MENU_TOGGLE = document.getElementById('product-navigation-toggle')

    FILTER_BTN.addEventListener('click', () => {
      SIDE_BAR.classList.add('show')
      NAV_TOGGLE.classList.add('hidden')
      MENU_TOGGLE.classList.add('show')
      setTimeout(() => {
        MENU_TOGGLE.classList.add('open')
      }, 100)
    })

    MENU_TOGGLE.addEventListener('click', () => {
      SIDE_BAR.classList.remove('show')
      MENU_TOGGLE.classList.remove('open')
      setTimeout(() => {
        NAV_TOGGLE.classList.remove('hidden')
        MENU_TOGGLE.classList.remove('show')
      }, 600)
    })
  }
}

/**
 * Get the start page number from mtt_search_obj.
 *
 * @returns number
 */
MTTSearch.prototype.getStartPage = function () {
  if (mtt_search_obj.params.page) {
    return parseInt(mtt_search_obj.params.page)
  }
  return 1
}

/**
 * Returns the post_type.
 *
 * @param form_class
 * @returns {{post_types: []}}
 */
MTTSearch.prototype.getPostTypes = function (form_class) {
  const post_types = []
  form_class.each(function () {
    post_types.push(jQuery(this).data('post_type'))
  })
  return { post_types }
}

/**
 * Add page number to the area_pages.
 *
 * @param page_number
 */
MTTSearch.prototype.addPage = function (page_number) {
  this.area_pages.push(page_number)
  this.area_pages.sort((a,b)=>a-b)
}

/**
 * Returns the highest page number that has been loaded.
 *
 * @returns number
 */
MTTSearch.prototype.getMaxLoadedPage = function () {
  return this.area_pages[this.area_pages.length - 1]
}

/**
 * Returns the lowest page number that has been loaded.
 *
 * @returns number
 */
MTTSearch.prototype.getLowestLoadedPage = function () {
  return this.area_pages[0]
}

/**
 * Toggle the loading icon on the area_form.
 * Makes a Ajax call with the inputs.
 */
MTTSearch.prototype.doSearch = function (current_page) {
  this.area_posts_per_page = this.area_form.find('[name="posts_per_page"]')
  this.area_order = this.area_form.find('[name="order"]')

  const sString = this.area_input.val()
  this.toggleLoading(this.area_form)
  const data = {
    action: mtt_search_obj.area.action,
    post_types: this.getPostTypes(this.area_post_types),
    search_string: sString,
    taxonomies: this.generateTaxonomiesObject(),
    slider_taxonomies: this.generateSliderTaxonomiesObject(),
    posts_per_page: this.area_posts_per_page.val(),
    page: current_page,
    order: this.area_order.val()
  }
  this.ajax(data, this.onAreaAjaxCallback.bind(this))
}

MTTSearch.prototype.onResetAreaClick = function (e) {
  e.preventDefault()

  this.resetInputFilters()
  this.resetTaxonomiesFilters()
  this.resetPostPerPageFilter()
  this.resetOrderFilter()
  this.resetSliderFilters()

  this.onAreaChange(e)

  this.resetPagination()
}

MTTSearch.prototype.stopSubmit = function (e) {
  e.preventDefault()
}

/**
 * Called when an input is changed.
 *
 * @param e
 */
MTTSearch.prototype.onAreaChange = function (e) {
  e.preventDefault()
  this.area_pages = []
  this.doSearch(1)
}

/**
 * Called when the load more button is clicked.
 *
 * @param e
 */
MTTSearch.prototype.onAreaLoadMore = function (e) {
  e.preventDefault()
  if ((this.getMaxLoadedPage() + 1) <= this.area_max_page) {
    this.doSearch(this.getMaxLoadedPage() + 1)
  }
}

/**
 * Called when the load prev button is clicked.
 *
 * @param e
 */
MTTSearch.prototype.onAreaLoadPrev = function (e) {
  e.preventDefault()
  if ((this.getLowestLoadedPage() - 1) >= 1) {
    this.doSearch(this.getLowestLoadedPage() - 1)
  }
}

/**
 * Return from the Ajax call, where it remove the loading icon.
 * Changes the search result with the new result.
 * Set's the area_current_page and adds the page to the area_pages.
 *
 * @param response
 */
MTTSearch.prototype.onAreaAjaxCallback = function (response) {
  this.toggleLoading(this.area_form, true)
  this.area_max_page = response.data.pages
  if (this.area_pages.length === 0) {
    this.area_products.html(response.data.html)
  } else {
    if (this.area_current_page > parseInt(response.data.page)) {
      this.area_products.prepend(response.data.html)
    } else {
      this.area_products.append(response.data.html)
    }
  }
  this.area_current_page = parseInt(response.data.page)
  this.addPage(parseInt(response.data.page))
  this.updatePagination(response.data.found_posts, response.data.pagination_type)
  this.buildAndPushState()
}

/**
 * Get all the loaded products.
 * Check if the found_posts is 0.
 * Sets the pagination html and width of the indicator.
 * Check if all the products has been loaded.
 * Check if the lowest area_pages is loaded.
 *
 * @param found_posts
 * @param pagination_type
 */
MTTSearch.prototype.updatePagination = function (found_posts, pagination_type) {
  let shown = this.area_form.find('.products li').not('.product-ad').length
  let indicator = 100 / found_posts * shown
  if (found_posts === 0) {
    shown = 0
    indicator = 0
  }
  this.area_pagination_progress_count_prev.html('Du har nu set ' + shown + ' af ' + found_posts + ' ' + pagination_type)
  this.area_pagination_indicator_prev.css('width', indicator + '%')
  this.area_pagination_progress_count.html('Du har nu set ' + shown + ' af ' + found_posts + ' ' + pagination_type)
  this.area_pagination_indicator.css('width', indicator + '%')
  if (shown === found_posts) {
    this.area_pagination_load_more.html('Alle ' + pagination_type + ' indlæst')
    this.area_pagination_load_more.addClass('disabled')
  } else {
    this.area_pagination_load_more.html('Indlæs flere')
    this.area_pagination_load_more.removeClass('disabled')
  }
  if (this.getLowestLoadedPage() === 1) {
    this.area_pagination_load_prev.html('Ingen tidligere ' + pagination_type)
    this.area_pagination_load_prev.addClass('disabled')
  } else {
    this.area_pagination_load_prev.html('Indlæs tidligere')
    this.area_pagination_load_prev.removeClass('disabled')
  }
}

/**
 * Add or removes the search bar wrapper.
 *
 * @param off
 */
MTTSearch.prototype.toggleSearchWrapper = function (off = false) {
  if (off) {
    this.bar_result_wrapper.hide()
    this.bar_result.html('')
    return
  }
  this.bar_result_wrapper.show()
}

/**
 * Add or removes the loading class and add or removes the loader element.
 *
 * @param form_class
 * @param off
 */
MTTSearch.prototype.toggleLoading = function (form_class, off = false) {
  if (off) {
    form_class.removeClass('loading')
    form_class.find('.loader').remove()
    return
  }
  form_class.addClass('loading')
  form_class.append(this.generateHTML('div', 'loader'))
}

/**
 * Returns all the taxonomy options that have been selected.
 *
 * @returns []
 */
MTTSearch.prototype.generateTaxonomiesObject = function () {
  const taxonomies = {}
  const tl = this.area_taxonomies.length
  for (let i = 0; i < tl; i++) {
    const element = jQuery(this.area_taxonomies[i])
    const taxonomy = element.data('taxonomy')
    if ((element.is(':checkbox') && !element.is(':checked')) || element.val() === '-1') {
      continue
    }
    if (taxonomies[taxonomy] === undefined) {
      taxonomies[taxonomy] = []
    }
    taxonomies[taxonomy].push(element.val())
  }
  if (this.category.data('product_cat') !== '') {
    taxonomies.product_cat = [this.category.data('product_cat')]
  }
  return taxonomies
}

MTTSearch.prototype.generateSliderTaxonomiesObject = function () {
  const sliderTaxonomies = {}
  const tsl = this.area_slider_taxonomies.length
  for (let i = 0; i < tsl; i++) {
    const element = jQuery(this.area_slider_taxonomies[i])
    const taxonomy = element.data('slider-taxonomy')

    if (sliderTaxonomies[taxonomy] === undefined) {
      sliderTaxonomies[taxonomy] = []
    }
    sliderTaxonomies[taxonomy].push(element.parent().find('[data-slider-min-value]').html())
    sliderTaxonomies[taxonomy].push(element.parent().find('[data-slider-max-value]').html())
  }

  return sliderTaxonomies
}

/**
 * Generate the url with the taxonomy options and push it to the url.
 */
MTTSearch.prototype.buildAndPushState = function () {
  if (window.history.pushState) {
    const searchParams = []
    if (this.area_input.val() !== '') searchParams.push('str=' + this.area_input.val())
    if (this.getMaxLoadedPage() !== 1) searchParams.push('page=' + this.getMaxLoadedPage().toString())
    if (this.area_order.val() !== '-1') searchParams.push('order=' + this.area_order.val())

    const taxonomies = this.generateTaxonomiesObject()
    if (taxonomies && Object.keys(taxonomies).length !== 0) {
      for (const [key, value] of Object.entries(taxonomies)) {
        if (key === 'product_cat' || key === 'order') { continue }
        searchParams.push('filter-' + key + '=' + value.join(','))
      }
    }

    const modifiedUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + searchParams.join('&')
    window.history.pushState({ path: modifiedUrl }, '', modifiedUrl)
  }
}

MTTSearch.prototype.resetInputFilters = function () {
  const inputs = this.area_form.find('input[type="search"]')

  for (let i = 0; i < inputs.length; i++) {
    inputs[i].value = ''
  }
}

MTTSearch.prototype.resetTaxonomiesFilters = function () {
  const tsl = this.area_taxonomies.length
  for (let i = 0; i < tsl; i++) {
    const element = this.area_taxonomies[i]
    if (element.type === 'checkbox') element.checked = false
    if (element.tagName === 'SELECT') {
      for (let j = 0; j < element.options.length; j++) {
        element.options[j].selected = false
      }
    }
  }
}

MTTSearch.prototype.resetPostPerPageFilter = function () {
  for (let i = 0; i < this.area_posts_per_page[0].options.length; i++) {
    this.area_posts_per_page[0].options[i].selected = false
  }
}

MTTSearch.prototype.resetOrderFilter = function () {
  for (let i = 0; i < this.area_order[0].options.length; i++) {
    this.area_order[0].options[i].selected = false
  }
}

MTTSearch.prototype.resetSliderFilters = function () {
  const tsl = this.area_slider_taxonomies.length
  for (let i = 0; i < tsl; i++) {
    const element = jQuery(this.area_slider_taxonomies[i])

    element.slider('values', 0, element.parent().find('[data-slider-min-value]').data('slider-min-value'))
    element.slider('values', 1, element.parent().find('[data-slider-max-value]').data('slider-max-value'))
    element.parent().find('[data-slider-min-value]').html(element.parent().find('[data-slider-min-value]').data('slider-min-value'))
    element.parent().find('[data-slider-max-value]').html(element.parent().find('[data-slider-max-value]').data('slider-max-value'))

    this.handleSliderNumber(element)
  }
}

MTTSearch.prototype.resetPagination = function () {
  const area_pagination_prev = jQuery('.mtt-search-content .mtt-pagination.prev')
  const area_pagination_next = jQuery('.mtt-search-content .mtt-pagination.next')

  area_pagination_prev.addClass('hidden')
  area_pagination_next.removeClass('hidden')
}

/**
 *
 *
 * @param data
 * @param callback
 */
MTTSearch.prototype.ajax = function (data, callback) {
  if (typeof this.mtt_search_ajax[data.action] === 'undefined') {
    this.mtt_search_ajax[data.action] = null // If no request have been made yet using this ajax_id, then set default
  }
  this.mtt_search_ajax[data.action] = jQuery.ajax({
    method: 'POST',
    url: this.ajax_url,
    data: data,
    beforeSend: () => {
      if (this.mtt_search_ajax[data.action] != null) {
        this.mtt_search_ajax[data.action].abort()
      }
    }
  }).done(callback).fail(callback)
}

/**
 * Debounce function, that let you set a wait time before an function need to be called.
 *
 * @param func
 * @param wait
 * @param immediate
 * @returns {function(...[*]=)}
 */
MTTSearch.prototype.debounce = function (func, wait, immediate) {
  let timeout

  return function () {
    const context = this
    const args = arguments

    const later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }

    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)

    if (callNow) func.apply(context, args)
  }
}

/**
 * Generate html.
 *
 * @param tag
 * @param classes
 * @param innerHTML
 * @returns {string}
 */
MTTSearch.prototype.generateHTML = function (tag, classes = '', innerHTML = '') {
  if (classes) {
    classes = ' class=\'' + classes + '\''
  }
  return '<' + tag + classes + '>' + innerHTML + '</' + tag + '>'
}

if (jQuery('form[' + mtt_search_obj.bar.selector + ']').length >= 0 || jQuery('form[' + mtt_search_obj.area.selector + ']').length >= 0) {
  window.mtt_search = new MTTSearch()
}
